import { useMemo } from "react";
import { hasRoles } from "../../../core/Global";
import SideMenu, { ISideMenuItem } from "../../../components/layouts/aside/SideMenu";
import { FontAwesomeIcons } from "../../../core/Types";


interface ISideMenuGroup {
    name: string
    items: Array<{
        id: string
        name: string
        icon: FontAwesomeIcons
        link: string
        roles: string[]
    }>
}

export function useVoiceSideMenuItems(): ISideMenuItem[] {
    return useMemo<ISideMenuItem[]>(() => {

        const groups: ISideMenuGroup[] = [
            {
                name: "Calls",
                items: [
                    { id: "calls-live", name: "Live Calls", icon: "tower-broadcast", link: "/voice/calls/live", roles: ["CallsHistory", "IsCustomer"] },
                    { id: "calls-history", name: "Calls History", icon: "clock-rotate-left", link: "/voice/calls/history", roles: ["CallsHistory", "IsCustomer"] },
                ]
            },
            {
                name: "PBX Modules",
                items: [
                    { id: "pbx-extensions", name: "Extensions", icon: "phone-office", link: "/voice/pbx/extensions", roles: ["ExtensionsList", "IsCustomer"] },
                    { id: "pbx-queues", name: "Queues", icon: "users", link: "/voice/pbx/queues", roles: ["QueuesList", "IsCustomer"] },
                    { id: "lines-active", name: "Phone Numbers", icon: "hashtag", link: "/voice/lines", roles: ["ListActiveNumbers", "IsCustomer"] },
                    { id: "lines-released", name: "Released Numbers", icon: "phone-slash", link: "/voice/released", roles: ["ListReleasedNumbers", "IsCustomer"] },
                    { id: "call-routing", name: "Call Routing", icon: "shuffle", link: "/voice/pbx/call-routing", roles: ["SystemSettings"] },
                    { id: "pbx-blocklist", name: "Block List", icon: "ban", link: "/voice/pbx/blocklist", roles: ["BlockedNumbersManage", "IsCustomer"] },
                ]
            },
        ]

        const result: ISideMenuItem[] = []
        for (const g of groups) {
            const visible = g.items.filter(it => hasRoles(it.roles))
            if (visible.length === 0) continue
            result.push({ seperator: true, name: g.name })
            for (const it of visible) {
                result.push({ id: it.id, name: it.name, icon: it.icon, link: it.link })
            }
        }
        return result

    }, [])
}


export default function VoiceSideMenu() {
    const items = useVoiceSideMenuItems()
    return <SideMenu items={items} />
}
